<template>
  <div id="container">
    <p class="u-loading" v-if="loading">正在加载，请稍候......</p>
    <div class="m-result" v-if="loaded">
      <trainTimes></trainTimes>
      <showTable :year="year" :month="month"></showTable>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import store from '../../../store/index.js'
  import {getSelect,curDate,getOtherDate} from '../../../assets/js/common.js'
  import searchBar from '../../common/searchBar.vue'
  import trainTimes from '../../common/trainTimes.vue'
  import showTable from './showTable.vue'

  export default ({
    store,
    data() {
      return {
        showTrain: false,  // 显示现场训练
        //数据加载中的标识
        loading: false,
        //数据加载完毕的标识
        loaded: false,
        search: {
          keyword: ''
        },
        caseLists: [],
        curPage: 1,
        totalNum: 1,
        cache : {}, //缓存页码及事件的对象
        detailDialog:false,//点击详细按钮弹窗
        chosePatientInfo:{},//选中患者信息
        chosePatientPlains:new Set(),//选中患者训练记录(测试用)
        chosePatientPlains2:{},//选中患者训练记录2
        year:"2018",
        month:"2",
      }
    },
    filters:{
      usetime(value) {
        var date = new Date(parseInt(value)*1000);
        var Y = date.getFullYear(),
          m = date.getMonth() + 1,
          d = date.getDate(),
          H = date.getHours(),
          i = date.getMinutes(),
          s = date.getSeconds();
        if (m < 10) {
          m = '0' + m;
        }
        if (d < 10) {
          d = '0' + d;
        }
        if (H < 10) {
          H = '0' + H;
        }
        if (i < 10) {
          i = '0' + i;
        }
        if (s < 10) {
          s = '0' + s;
        }
        var t = Y + '.' + m + '.' + d + ' ' + H + ':' + i;
        return t;
      }
    },
    computed: {
      tableH: function(){
        return (document.body.clientHeight - 600)+'px';
      }
    },
    components: {
      searchBar,
      trainTimes,
      showTable
    },
    mounted () {
      this.rechangeYearMoth();
      this.filtrate(this.curPage);
    },
    watch:{
      year:function (newVal,oldVal) {//监听年份的变化
        var self = this;
        let year = newVal;
        let month = self.month;
      },
      month:function (newVal,oldVal){//监听月份的变化
        var self = this;
        let year = self.year;
        let month = newVal;
      }
    },
    methods: {
      close(){
        this.detailDialog = false;
      },
      rechangeYearMoth(){//初始化年月
        let nowDate = new Date();
        this.year = nowDate.getFullYear();
        this.month = nowDate.getMonth()+1;
      },
      filtrate(curPage,pageNum){
        var self = this;
        self.loading= true;
        self.loaded= false;
        if (self.cache[curPage]) {
          self.loading= false;
          self.loaded= true;
          self.caseLists = self.cache[curPage].data;
          self.totalNum = self.cache[curPage].page.total;
        }else{
          Vue.http({
            method: 'GET',
            url:'/api/Train/recordTM',
            params: {
              'year':self.year,
              'month':self.month,
              'page': curPage,
              'per_page':pageNum,
              'search': this.search.keyword,
            }
          })
        .then(function(res){
              self.loading= false;
              self.loaded= true;
              var trueData = res.data.data;
              self.caseLists = trueData;
              self.totalNum = res.data.total;
            }
          );
        }
      },
      handleClick: function(newIndex){
        this.curPage = newIndex;
        this.filtrate(newIndex,10);
      },
      searchList: function(val) {
        this.search = val;
        this.filtrate();
      },
      showMore: function(patientInfo) {
        var self = this;
        self.chosePatientInfo = patientInfo;
        Vue.http({
          method: 'GET',
          url:'/api/Train/detailTM',
          params: {
            'record_id': patientInfo.id
          }
        }).then(res=>{
          self.detailDialog = true;
          let trueData = res.data.data;
          self.getAllPlainName(trueData);//处理训练数据结果
        });
      },
      getAllPlainName(data){
        var self = this;
        var data = data.checked;
        let tmpPlains = {
          'yy':[],
          'rz':[]
        };
        for(let plain in data){
          switch(data[plain]['type']){
            case '10':
              if(data[plain]['counts'] != '0'){
                tmpPlains.yy.push(data[plain]['name']+"*"+data[plain]['counts']);
              }
              break;
            case '20':
              if(data[plain]['counts'] != '0') {
                tmpPlains.rz.push(data[plain]['name'] + "*" + data[plain]['counts']);
              }
              break;
            default:
              break;
          }
        }
        self.chosePatientPlains2 = tmpPlains;
      }
    },
    destroyed() {
      this.loading= false;
      this.loaded= false;
    }
  })
</script>

<style lang="stylus" scoped>
  @import "../../../assets/css/app.styl";

  #container
    position absolute
    top 80px
    left 229px
    right 0
    border-left 1px solid #eee
    a
      color $color-font-primary
    .containMore
      position relative
  .dialog-table{
    border-left: 0!important;
  }
  table tbody tr {
    height: 40px;
    border-bottom: 0;
  }
  table tbody tr td{
    text-align:left;
    font-size:14px;
  }
  .td-left{
    text-align:right;
    width:150px;
  }
  .dialog-title{
    text-align:center;
    font-size:22px;
    color:rgba(0, 0, 0, 0.87);
  }
  .dialog-footer{
    text-align:center;
  }
  .dialog-btn{
    width:120px;
    height:40px;
    background-color:#0a81e5;
    font-size:14px;
  }
</style>



// WEBPACK FOOTER //
// timeList.vue?2e36434d